module.exports = __webpack_public_path__ + "img/profile.16cebda0.jpeg";